module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei1.svg";